<template>
    <form class="item_link_form">

        <h4>{{ $t('Add link') }}</h4>
        <div>
            <div class="input_item">
                <div class="p-float-label with-button">
                    <InputText id="url" type="text" v-model="formData.url" />
                    <label for="url">{{ $t("URL to add to the link collection") }}</label>
                </div>
            </div>

            <MultiSelect
                v-model="formData.types"
                :options="itemLinkTypes"
                optionLabel="name"
                :placeholder="$t('ItemLinkType.MultiSelectPlaceholder')"
                display="chip"/>

            <Button
                type="button"
                :label="$t('Link Add')"
                class="p-button-outlined"
                @click="onClickStoreItemLink"
                />
        </div>

        <p>
            {{ $t('')}}
        </p>

    </form>

</template>

<script>
import {
    ref,
    onMounted,
    reactive,
} from 'vue';
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import axios from "axios";
import Message from 'primevue/message';
import { useToast } from "primevue/usetoast";
import { errorToast } from './../../../itemListError.js';
import MultiSelect from 'primevue/multiselect';

export default {
    components: {
        Button,
        InputText,
        Message,
        MultiSelect,
    },
    props: {
        item_id: {
            type: Number,
            default: ""
        },
    },
    setup(props) {
        const toast = useToast();

        const formData = reactive({
            url: "",
            types: [],
        })
        const itemLinkTypes = ref();

        const load = () => {
            itemLinkTypes.value = JSON.parse(document.getElementById("json-data-item_link_types").textContent)
        }

        onMounted(load);

        const onClickStoreItemLink = function() {
            const postData = {
                item_id: props.item_id,
                url:formData.url,
                types: formData.types.flatMap((element) => {
                    return element['code']
                }),
            }
            axios.post(
                '/api/item_links',
                postData,
            ).then(res => {
                location.href = '/items/' + String(props.item_id);
            }).catch(error => {
                errorToast(error.response.data, toast);
            })
        }
        return {
            formData,
            itemLinkTypes,
            onClickStoreItemLink,
        }
    },
}
</script>


